import { currencyFormat } from 'common/helpers/numberHelper';

const BottleDeposit = (props) => {
  const { order, settings } = props;
  if (!order.bottleDepositTotal || order.bottleDepositTotal === 0) {
    return null;
  }
  return (
    <div>
      <div>Bottle Deposit</div>
      <div>{currencyFormat(order.bottleDepositTotal, settings)}</div>
    </div>
  );
};

export default BottleDeposit;
